import { render, staticRenderFns } from "./Imposto.vue?vue&type=template&id=1350312e&scoped=true&"
import script from "./Imposto.vue?vue&type=script&lang=js&"
export * from "./Imposto.vue?vue&type=script&lang=js&"
import style0 from "./Imposto.vue?vue&type=style&index=0&id=1350312e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350312e",
  null
  
)

export default component.exports